
import Vue from "vue";
import { validate_file_type, get_file_size } from "@/utils/global";
import { mapMutations } from "vuex";
import { ROOT_ERROR } from "@/store/modules/root/constants";

export default Vue.extend({
  name: "CVUpload",
  props: {
    accept: {
      type: String,
      // Limit CV upload to common document formats only
      default: ".pdf,.doc,.docx,.txt"
    },
    maxSize: {
      type: Number,
      // Maximum file size in MB
      default: 10
    }
  },
  data() {
    return {
      selectedFile: null as File | null,
      isDragOver: false,
      fileIcon: require("@/assets/head/upload.svg"),
      closeIcon: require("@/assets/icons/bold/close-circle.svg")
    };
  },
  methods: {
    ...mapMutations({
      set_root_error: ROOT_ERROR
    }),
    triggerFileInput() {
      (this.$refs.fileInputRef as HTMLInputElement)?.click();
    },
    onFileSelect(event: Event) {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        this.handleFileUpload(target.files[0]);
      }
    },
    onDrop(event: DragEvent) {
      event.preventDefault();
      this.isDragOver = false;
      if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
        this.handleFileUpload(event.dataTransfer.files[0]);
      }
    },
    validateFile(file: File): boolean {
      const allowedTypes = this.accept
        .split(",")
        .map((type) => type.trim().toLowerCase())
        .filter((type) => !!type);
      const fileExtension = "." + file.name.split(".").pop()?.toLowerCase();

      // Check file extension
      if (!allowedTypes.includes(fileExtension)) {
        this.set_root_error(this.$t("candidate-onboarding.unsupported-error"));
        return false;
      }

      // Check file type using utility helpers for PDF, text, and Word docs
      const isValidType =
        validate_file_type("pdf", file) ||
        validate_file_type("text", file) ||
        validate_file_type("word", file);

      if (!isValidType) {
        this.set_root_error(this.$t("candidate-onboarding.unsupported-error"));
        return false;
      }

      // Check file size
      if (file.size > this.maxSize * 1024 * 1024) {
        this.set_root_error(this.$t("candidate-onboarding.resume-size-error"));
        return false;
      }

      return true;
    },
    handleFileUpload(file: File) {
      if (!this.validateFile(file)) {
        return;
      }

      this.selectedFile = file;
      this.$emit("file-selected", file);
    },
    removeFile() {
      this.selectedFile = null;
      const input = this.$refs.fileInputRef as HTMLInputElement;
      if (input) {
        input.value = "";
      }
      this.$emit("file-removed");
    }
  },
  computed: {
    fileSize(): string {
      if (this.selectedFile) {
        return get_file_size(this.selectedFile.size);
      }
      return "";
    }
  }
});
